/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
  NbSpinnerModule,
  NbAlertModule,
  NbIconModule,
  NbInputModule,
  NbButtonModule,
  NbCheckboxModule,
} from '@nebular/theme';
import { NbAuthModule, NbPasswordAuthStrategy, NbAuthJWTToken, routes } from '@nebular/auth';
import { AuthGuard } from './app-auth-guard';
import { AppCoverPageComponent } from './cover-page/app-cover-page.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { EpicService } from './pages/event/event.service';
import { ThemeModule } from './@theme/theme.module';
import { AppMentionPageComponent } from './cover-page/app-mention-page.component';
import { CKEditorModule } from 'ng2-ckeditor';
import { RouterModule } from '@angular/router';
import { RoleProvider } from './pages/role.service';
import { CustomLoginComponent } from './custom-login/custom-login.component';
import { CustomRegisterComponent } from './custom-register/custom-register.component';
import { AppPolicyPageComponent } from './cover-page/app-policy-page.component';



@NgModule({
  declarations: [AppComponent,AppCoverPageComponent,AppPolicyPageComponent,AppMentionPageComponent, CustomLoginComponent, CustomRegisterComponent],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes, { anchorScrolling: 'enabled'}),
    BrowserAnimationsModule,
    CKEditorModule,
    NbAlertModule,
    NbIconModule,
    NbInputModule,
    NbButtonModule,
    NbCheckboxModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ThemeModule.forRoot(),
    NbSpinnerModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({
          name: 'email',
          token: {
            class: NbAuthJWTToken,
            key: 'access_token', 
          },

          baseEndpoint: environment.root,
           login: {
             method: 'post',
             endpoint: '/login',
           },
           register: {
             method: 'post',
             endpoint: '/register',
           },
           requestPass: {
            method: 'post',
            endpoint: '/request-pass',
          },
          resetPass: {
            method: 'post',
            endpoint: '/reset-pass',
          },
        })
      ],
      forms: {},
    }), 
  ],
  bootstrap: [AppComponent],
  providers: [RoleProvider,AuthGuard,EpicService]
})
export class AppModule {
}
